import { HttpInterceptorFn } from '@angular/common/http';

const authCookieInterceptor: HttpInterceptorFn = (request, next) =>
  next(
    request.clone({
      withCredentials: true,
    })
  );

export default authCookieInterceptor;
